export const secureIframe = async (iframeSelector: string) =>
    new Promise((resolve, reject) => {
        const iframe = window.document.querySelector(iframeSelector);

        if (iframe instanceof HTMLIFrameElement) {
            iframe.setAttribute('sandbox', '');
            resolve(iframe);
        }
        reject(iframeSelector);
    });
